<template>
  <div class="bg-color">
    <div class="sectionHeader isFixed" ref="mainHeader" v-if="showHeader">
      <div class="">
        <mainHeader class="mainHeader"></mainHeader>
      </div>
    </div>

    <div ref="searchBar" :style="{top: !showHeader?'0':mainHeight + 'px'}" id="shop_main_top_layout"
      :class="['shop-main-top-layout', 'flex-row', 'ct',showHeader?'':'top']">
      <div class="flex-column ct shop-main-top-classify-layout" v-on:click="classifyClick">
        <img v-show="!this.classifyPopShow" src="../images/ic_index_classify_gray.png">
        <img v-show="this.classifyPopShow" src="../images/ic_index_classify_red.png">
        <span
          v-bind:class="[this.classifyPopShow ? 'shop-main-top-classify-layout-select' : 'shop-main-top-classify-layout-unselect']">分类</span>
      </div>
      <div class="shop-main-line2"></div>
      <div class="shop-main-top-search-layout flex-row flex ct">
        <!-- <img src="../../../assets/icon_search.png"> -->
        <div class="shop-main-top-search-change-layout flex-row ct" @click="changeShopOrBuyState()">
          <span v-if="shopState === 1">搜商品 ▾</span>
          <span v-else>搜采购 ▾</span>
        </div>
        <div class="clearX" @click="Clear" v-if="resetClear"></div>
        <input v-model="searchStr" @keyup.13="startSearch" ref="input1" class="flex" type="text" placeholder="请输入关键字"
          @input="onTyping(searchStr)" maxlength="10" v-on:focus="onFocus" @blur="onBlur" />
      </div>
      <div class="shop-main-top-search-btn" v-on:click="startSearch">搜索</div>
    </div>
    <quickSearch ref="quickSearch" :style="{top:!showHeader?searchHeight + 'px':calcHeight+'px'}"
      @changePosition="slide" @getSearchKey="searchKey" v-if="shopState === 1">
    </quickSearch>
    <index-complex @indexCPopSelect="indexCPopSelect" @indexCPopEmit="indexCPopEmit" :ic-pop-show="indexComplexPopShow"
      :ic-scroll-y="scrollY" :isApp="showHeader" :position="slidFlag"
      :toTop="!showHeader?searchHeight+navHeight: calcHeight+navHeight" v-if="shopState === 1"/>

    <index-buy-complex :style="{top:!showHeader?searchHeight + 'px':calcHeight+'px'}" v-if="shopState === 2"
      :key-str="searchStr" :f-cids="fCids" :s-cids="sCids" :t-cids="tCids" :buy-search-index="buySearchIndex"></index-buy-complex>

    <div class="shop-main-center" ref="main" v-if="shopState === 1"
      :style="{paddingTop: !showHeader?searchHeight+navHeight +'px': calcHeight+navHeight + 'px'}">
      <!-- <div class="shop-main-line bg-color" v-if="showHeader">
      </div> -->

      <div :class="['shop-main-empty',showHeader?'':'top']" v-show="shopList.length <= 0">暂无数据</div>
      <van-pull-refresh v-show="shopList.length > 0" :class="['shop-main-list',showHeader?'':'top']" v-model="isRefresh"
        success-text="刷新成功" @refresh="onRefresh" >
        <van-list v-model="isLoadMore" :offset="250" :immediate-check="false" :finished="noLoadMoreData"
          finished-text="没有更多了" @load="onLoadMore" :error.sync="loadMoreError">
          <div class="van-clearfix">
            <!-- item 属性有float时，需要在item中添加 van-clearfix，否则会一直加载更多 -->
            <div class="shop-main-list-item-layout" v-for="(item,index) in shopList" :key="index"
              v-on:click.stop="onItemClick(item,index)">
              <img v-bind:src="item.product_cover">
              <div class="shop-main-list-item-bottom-layout flex-column">
                <!-- <i class="goods-comm-img"></i> -->
                <div class="shop-main-list-item-title m-top">
                  <img class="goods-comm-icon" v-if="item.tails.isVipSupplier&&item.tails.isVipSupplier==1" src="https://cdn.zxzx119.com/zxzx-mall-applet/image/ssvip-icon.png" alt="" srcset="">
                  {{item.product_name}}
                </div>
                <span
                  class="shop-main-list-item-city m-top">{{(item.tails === undefined || item.tails === null
                || item.tails.city === undefined || item.tails.city === null || item.tails.city === '') ? '暂无城市' : item.tails.city}}
                </span>
                <div class="m-top m-bottom">
                  <div v-if="item.tails.telephone_bargain == 0">
                    <span class="shop-main-list-item-yuan">￥</span>
                    <span class="shop-main-list-item-price"
                      v-if="item.tails.discount_price === undefined">{{Math.round(item.tails.original_price)/100}}</span>
                    <span class="shop-main-list-item-price" v-else>{{Math.round(item.tails.discount_price)/100}}</span>
                  </div>
                  <span v-else class="shop-main-list-item-price">电议</span>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <index-classify-pop :classify-list1="classifyList" :index1="classifyIndex1" :index2="classifyIndex2"
      :index3="classifyIndex3" :selected-classify-list2="selectedClassifyList2" :isApp="showHeader"
      :selected-classify-list3="selectedClassifyList3" v-show="classifyPopShow" @onIndexPopSelect="onIndexPopSelect" />
  </div>
</template>

<script>
// 引入
import { Toast } from 'mint-ui'
import mainHeader from '@/view/header'
import IndexClassifyPop from './index-classify-pop'
import IndexComplex from './index-complex'
import quickSearch from '@/components/quickSearch'
import IndexBuyComplex from './index-buy-complex'
export default {
  name: 'index',
  components: { IndexComplex, IndexClassifyPop, mainHeader, quickSearch, IndexBuyComplex },
  data () {
    return {
      calcHeight: 0,
      mainHeight: 0,
      searchHeight: 0,
      navHeight: 0,
      slidFlag: false,
      scrollY: 0,
      isFrist: true,
      isRefresh: false,
      isLoadMore: false,
      noLoadMoreData: false,
      loadMoreError: false,
      requestState: 0, // 0：表示刷新；1表示加载更多
      pageNo: 1,
      pageSize: 10,
      classifyPopShow: false,
      classifyIndex1: 0,
      classifyIndex2: -1,
      classifyIndex3: -1,
      searchStr: '', // 关键词
      fCids: '-1', // 一级分类id35
      sCids: '-1', // 二级分类id36
      tCids: '-1', // 三级分类id46
      indexComplexPopShow: false,
      orderType: '1', // 1综合 2人气 3新品  4价格升序 5价格降序 6电议  7推荐排序
      area: '全部', // 所在地查询
      classifyList: [], // 分类数据
      selectedClassifyList2: [], // 选中的二级分类数据
      selectedClassifyList3: [], // 选中的三级分类数据
      shopList: [], // 商品数据
      headerFixed: '',
      showHeader: true,
      posist: '',
      resetClear: false,
      shopState: 1, // 1:表示 商城；2：表示采购
      buySearchIndex: 0, // 表示采购状态下 点击搜索按钮的次数
      buyReqUrl: '' // 采购页面后缀需要拼接的url，目前已废弃不用
    }
  },
  methods: {
    keyboardState (style) { // 1:显示 2:隐藏
      if (style == 2) {
        this.$refs.input1.blur()
      }
    },
    onTyping (str) {
      this.resetClear = str.length > 0
    },
    Clear () {
      this.searchStr = ''
      this.resetClear = false
    },
    getHeightcalc () {
      // mainHeader  searchBar quickSearch
      this.mainHeight = this.$refs.mainHeader ? this.$refs.mainHeader.getBoundingClientRect().height : 0
      this.searchHeight = this.$refs.searchBar.getBoundingClientRect().height
      this.calcHeight = this.mainHeight + this.$refs.searchBar.getBoundingClientRect().height
      let refs = this.$refs.quickSearch
      if (refs !== undefined) {
        this.navHeight = refs.$el.clientHeight
      }
    },
    slide (data) {
      this.slidFlag = data
      setTimeout(() => {
        this.getHeightcalc()
        this.scrollY = 10
      }, 500)
    },
    changeShopOrBuyState () {
      if (this.shopState === 1) {
        this.shopState = 2
      } else {
        this.shopState = 1
        this.onRefresh()
        if (this.showHeader) {
          if (this.$refs.mainHeader.getBoundingClientRect().top <= 0) {
            this.posist = 'fixed'
          } else {
            this.posist = 'relative'
          }
          this.scrollY = window.pageYOffset
        } else {
          this.posist = 'fixed'
        }
      }
    },
    searchKey (data) {
      this.fCids = '-1'
      this.sCids = '-1'
      this.tCids = '-1'
      this.searchStr = data
      this.startSearch()
    },
    onFocus: function () {
      this.$emit('getFocus', false)
      if (this.classifyPopShow) {
        this.classifyPopShow = false
        this.canScroll()
      }
      if (this.indexComplexPopShow) {
        this.indexComplexPopShow = false
        this.canScroll()
      }
    },
    onBlur () {
      this.$emit('getFocus', true)
    },
    startSearch: function () { // 开始搜索
      const str = this.searchStr.replace(/\s+/g, '')
      if (str.length <= 0 || str === '') {
        // Toast('请输入关键字')
        this.$refs.input1.blur() // 让输入法自动消失
        if (this.shopState === 1) {
          this.requestState = 0
          this.pageNo = 1
          this.autoToTop()
          this.getShopListData()
        } else {
          this.buySearchIndex++
          // this.getBuyReqUrl()
        }
      } else {
        const regex = '^[\u4E00-\u9FA50-9a-zA-Z]+$'
        if (str.match(regex)) {
          this.$refs.input1.blur() // 让输入法自动消失
          if (this.shopState === 1) {
            this.requestState = 0
            this.pageNo = 1
            this.autoToTop()
            this.getShopListData()
          } else {
            this.buySearchIndex++
            // this.getBuyReqUrl()
          }
        } else {
          Toast('只能输入中文、英文、数字')
        }
      }
    },
    classifyClick: function () { // 分类点击
      this.classifyPopShow = !this.classifyPopShow
      if (this.indexComplexPopShow) {
        this.indexComplexPopShow = false
      }
      if (this.classifyPopShow) {
        this.stopScroll()
      } else {
        this.canScroll()
      }
    },
    getClassifyData: function () { // 获取分类数据
      const that = this
      this.utils.GET(this.accountUrl + '/mallCategory/threeLevelList', function (resultData) {
        if (resultData.success) {
          that.classifyList = resultData.data
          that.classifyList.splice(0, 0, {
            category_name: '全部',
            id: -1,
            sonList: []
          })
          that.findClassifyIndexByClassifyData()
        }
      })
    },
    findClassifyIndexByClassifyData: function () { // 根据选中的 分类id获取到 与之对应的List下标
      // console.log('fCids ---> ' + this.fCids)
      // console.log('sCids ---> ' + this.sCids)
      // console.log('tCids ---> ' + this.tCids)
      if (this.fCids !== '-1') { // 一级分类
        this.classifyList.every((item, index) => {
          if (item.id.toString() === this.fCids) {
            this.classifyIndex1 = index
            return false
          } else {
            return true
          }
        })
      }
      if (this.sCids !== '-1' && this.classifyIndex1 !== -1) { // 二级分类
        // 获取二级分类数据
        let sonList = this.classifyList[this.classifyIndex1].sonList
        sonList.splice(0, 0, { // 与Pop中的数据保持一致
          category_name: '全部',
          id: -1,
          sonList: []
        })
        sonList.every((item, index) => {
          if (item.id.toString() === this.sCids) {
            this.classifyIndex2 = index
            return false
          } else {
            return true
          }
        })
        this.selectedClassifyList2 = sonList
        console.log('classifyIndex2 ---> ' + this.classifyIndex2)
        // 三级分类
        if (this.tCids !== '-1' && this.classifyIndex2 !== -1 && sonList.length > 0) {
          // 获取三级分类数据
          let sonList2 = sonList[this.classifyIndex2].sonList
          sonList2.splice(0, 0, { // 与Pop中的数据保持一致
            category_name: '全部',
            id: -1
          })
          sonList2.every((item, index) => {
            if (item.id.toString() === this.tCids) {
              this.classifyIndex3 = index
              return false
            } else {
              return true
            }
          })
          this.selectedClassifyList3 = sonList2
          console.log('classifyIndex3 ---> ' + this.classifyIndex3)
        }
      }
    },
    getShopListData: function () { // 获取商品列表数据
      const that = this
      this.utils.GET(this.getShopListRequestUrl(), function (resultData) {
        that.isFrist = false
        if (resultData.success) { // TODO 请求成功
          const list = resultData.data.rows
          if (that.requestState === 0) { // 刷新
            that.isRefresh = false
            // that.shopList.splice(0, that.shopList.length)
            that.shopList = []
            if (list === null || list.length <= 0) {
              Toast('暂无数据')
            } else {
              that.shopList = list
              that.noLoadMoreData = false
            }
          } else if (that.requestState === 1) { // 加载更多
            that.isLoadMore = false
            if (list === null || list.length <= 0) {
              that.noLoadMoreData = true
            } else {
              that.shopList = that.shopList.concat(list)
            }
            if (that.loadMoreError) {
              that.loadMoreError = false
            }
          }
        } else { // TODO 请求失败
          Toast('网络不给力啊，再试一次吧！')
          if (that.requestState === 0) { // 刷新
            that.isRefresh = false
          } else if (that.requestState === 1) { // 加载更多
            that.loadMoreError = true
            // TODO 请求失败，是否需要给page减减，因为再次点击重新请求，page又会在加加
            that.pageNo--
          }
        }
      })
    },
    getShopListRequestUrl: function () { // 获取商品请求url
      let url = this.accountUrl + '/goods/goodsList?page=' + this.pageNo + '&rows=' +
        this.pageSize + '&orderType=' + this.orderType
      console.log(this.searchStr)
      if (this.searchStr === undefined) {
        url = url + '&key=' + ''
      } else if (this.searchStr.length >= 0) {
        url = url + '&key=' + this.searchStr
      }
      if (this.fCids.length > 0 && this.fCids !== '-1') {
        url = url + '&fCids=' + this.fCids
      }
      if (this.sCids.length > 0 && this.sCids !== '-1') {
        url = url + '&sCids=' + this.sCids
      }
      if (this.tCids.length > 0 && this.tCids !== '-1') {
        url = url + '&tCids=' + this.tCids
      }
      if (this.area !== '全部') {
        url = url + '&area=' + this.area
      }
      // console.log('请求url ---> ' + url)
      this.spliceUrlForBrowser()
      return url
    },
    spliceUrlForBrowser: function () { // 在浏览器地址栏拼接 url
      // 目的是为了即使用户复制url到其他地方，也能够保持当前选择的值
      const url = this.$route.path + '?fCids=' + this.fCids + '&sCids=' + this.sCids + '&tCids=' + this.tCids
      window.history.replaceState('', '', url)
    },
    onRefresh: function () {
      this.requestState = 0
      this.pageNo = 1
      this.getClassifyData()
      this.getShopListData()
    },
    onLoadMore: function () {
      if (this.isFrist) {
        console.log('第一次加载，手动干预不执行加载更多')
        this.isLoadMore = false
      } else {
        this.requestState = 1
        this.pageNo++
        this.getShopListData()
      }
    },
    onItemClick: function (item, index) { /* 列表item点击 */
      this.$router.push({ path: '/goodsdetail',
        query: {
          goodsId: item.id,
          businessId: item.supplier_id
        }
      })
    },
    onIndexPopSelect: function (childCount, item1, item2, item3, index1, index2, index3) { // 分类点击
      this.searchStr = ''
      this.classifyPopShow = false
      switch (childCount) {
        case 0:
          console.log('cancel')
          break
        case 1:
          this.classifyIndex1 = index1
          this.fCids = item1.id + ''
          this.sCids = '-1'
          this.tCids = '-1'
          // console.log('一级 ---> ' + item1.category_name + ' --- id：' + item1.id)
          // console.log('==========================================================')
          if (this.shopState === 1) {
            this.requestState = 0
            this.pageNo = 1
            this.autoToTop()
            this.getShopListData()
          } else {
            // this.getBuyReqUrl()
          }
          break
        case 2:
          this.classifyIndex1 = index1
          this.classifyIndex2 = index2
          this.fCids = item1.id + ''
          this.sCids = item2.id + ''
          this.tCids = '-1'
          // console.log('一级 ---> ' + item1.category_name + ' --- id：' + item1.id)
          // console.log('二级 ---> ' + item2.category_name + ' --- id：' + item2.id)
          // console.log('==========================================================')
          if (this.shopState === 1) {
            this.requestState = 0
            this.pageNo = 1
            this.autoToTop()
            this.getShopListData()
          } else {
            // this.getBuyReqUrl()
          }
          break
        case 3:
          this.classifyIndex1 = index1
          this.classifyIndex2 = index2
          this.classifyIndex3 = index3
          this.fCids = item1.id + ''
          this.sCids = item2.id + ''
          this.tCids = item3.id + ''
          // console.log('一级 ---> ' + item1.category_name + ' --- id：' + item1.id)
          // console.log('二级 ---> ' + item2.category_name + ' --- id：' + item2.id)
          // console.log('三级 ---> ' + item3.category_name + ' --- id：' + item3.id)
          // console.log('==========================================================')
          if (this.shopState === 1) {
            this.requestState = 0
            this.pageNo = 1
            this.autoToTop()
            this.getShopListData()
          } else {
            // this.getBuyReqUrl()
          }
          break
      }
      localStorage.setItem('homeParam', '?fCids=' + this.fCids + '&sCids=' + this.sCids + '&tCids=' + this.tCids)
      this.canScroll()
    },
    indexCPopSelect: function (index, value) { // 综合、价格、地区选中
      switch (index) {
        case 0: // 综合
          this.orderType = value
          console.log('综合选中： ' + value)
          break
        case 1: // 品牌
          break
        case 2: // 价格
          this.orderType = value
          console.log('价格选中： ' + value)
          break
        case 3: // 地区
          this.area = value
          console.log('地区选中： ' + value)
          break
      }
      this.requestState = 0
      this.pageNo = 1
      this.autoToTop()
      this.getShopListData()
    },
    indexCPopEmit: function (isPopShow) { // 子组件通知父组件改变状态
      if (isPopShow) {
        this.stopScroll()
      } else {
        this.canScroll()
      }
      this.indexComplexPopShow = isPopShow
    },
    // getBuyReqUrl: function() { // 获取 采购列表 后缀url
    //   var url = ''
    //   url = url + '&key=' + this.searchStr
    //   if (this.fCids.length > 0 && this.fCids !== '-1') {
    //     url = url + '&fCids=' + this.fCids
    //   } else {
    //     url = url + '&fCids='
    //   }
    //   if (this.sCids.length > 0 && this.sCids !== '-1') {
    //     url = url + '&sCids=' + this.sCids
    //   } else {
    //     url = url + '&sCids='
    //   }
    //   if (this.tCids.length > 0 && this.tCids !== '-1') {
    //     url = url + '&tCids=' + this.tCids
    //   } else {
    //     url = url + '&tCids='
    //   }
    //   this.buyReqUrl = url
    // },
    stopScroll: function () { // 禁止滚动
      document.body.style.overflow = 'hidden'
    },
    canScroll: function () { // 取消滑动限制
      document.body.style.overflow = ''
    },
    autoToTop: function () {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    },
    addScrollListener: function (e) {
      document.addEventListener('scroll', this.onScroll, true)
    },
    onScroll: function () { // 滚动事件
      let flag = false
      if (this.showHeader) {
        this.scrollY = window.pageYOffset
      } else {
        this.posist = 'fixed'
      }
      if (this.$refs.main.getBoundingClientRect().top < 0 && flag === false) {
        this.$refs.quickSearch.reset()
        flag = true
      } else if (this.$refs.main.getBoundingClientRect().top === 0 && flag === true) {
        this.$refs.quickSearch.slide(0)
        flag = false
      }
    },
    getSearchStr: function (state) { // 获取上个页面传过来的搜索关键字
      let str = this.$route.query.key
      if (str !== undefined) {
        this.searchStr = str
        this.onTyping(str)
      }
    },
    getShopState: function (state) { // 获取上个页面传过来的状态
      let shopState = parseInt(this.$route.query.shopState)
      if (String(shopState) !== 'NaN' && shopState !== undefined && shopState !== this.shopState) {
        this.shopState = shopState
      }
    },
    isMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    },
    jump () {
      let obj = this.$route.query
      if (!this.isMobile()) {
        if (obj.fCids == -1 && obj.sCids == -1 && obj.tCids == -1) {
          window.location.href = 'https://www.zxzx119.com/shopsearch'
        } else if (obj.fCids != -1 && obj.sCids == -1 && obj.tCids == -1) {
          window.location.href = 'https://www.zxzx119.com/shopsearch?ids=' + obj.fCids
        } else if (obj.fCids == -1 && obj.sCids != -1 && obj.tCids == -1) {
          window.location.href = 'https://www.zxzx119.com/shopsearch?ids=' + obj.fCids + ',' + obj.sCids
        } else if (obj.fCids != -1 && obj.sCids != -1 && obj.tCids != -1) {
          window.location.href = 'https://www.zxzx119.com/shopsearch?ids=' + obj.fCids + ',' + obj.sCids + ',' + obj.tCids
        }
      }
    }
  },
  created () {
    this.addScrollListener()
    if (this.$route.query.isApp == 1 && this.$route.query.type == 1) {
      localStorage.setItem('enterType', this.$route.query.type)
      localStorage.setItem('isApp', this.$route.query.isApp)
    }
    if (this.$route.query.isApp == 1 || localStorage.getItem('isApp') == 1) {
      this.showHeader = false
    } else {
      this.showHeader = true
    }
    console.log(this.showHeader)
  },
  beforeRouteEnter (to, from, next) {
    if (from.name === '/home') {
      localStorage.setItem('fromHome', true)
    }
    next()
  },
  beforeRouteLeave (to, from, next) {
    if (to.name !== '/home') {
      localStorage.setItem('fromHome', false)
    }
    next()
  },
  activated () {
    this.jump()
    this.getHeightcalc()
    this.getSearchStr('activated')
    this.getShopState('activated')
    if (this.shopState === 2) {
      this.buySearchIndex++
    }
    let from = localStorage.getItem('fromHome')
    if (from === 'true') {
      let fCids = this.$route.query.fCids
      let sCids = this.$route.query.sCids
      let tCids = this.$route.query.tCids
      if (fCids !== undefined) {
        this.fCids = fCids
      }
      if (sCids !== undefined) {
        this.sCids = sCids
      }
      if (tCids !== undefined) {
        this.tCids = tCids
      }
      this.spliceUrlForBrowser()
      this.autoToTop()
      this.onRefresh()
    } else {
      if (this.shopState === 1) {
        this.spliceUrlForBrowser()
        this.autoToTop()
        this.onRefresh()
      }
    }
  },
  mounted () {
    this.getSearchStr('mounted')
    this.getShopState('mounted')
    let fCids = this.$route.query.fCids
    let sCids = this.$route.query.sCids
    let tCids = this.$route.query.tCids
    if (fCids !== undefined) {
      this.fCids = fCids
    }
    if (sCids !== undefined) {
      this.sCids = sCids
    }
    if (tCids !== undefined) {
      this.tCids = tCids
    }
    this.spliceUrlForBrowser()
    this.autoToTop()
    this.onRefresh()
    this.getHeightcalc()
    if (this.showHeader) {
      if (this.$refs.mainHeader.getBoundingClientRect().top <= 0) {
        this.posist = 'fixed'
      } else {
        this.posist = 'relative'
      }
      this.scrollY = window.pageYOffset
    } else {
      this.posist = 'fixed'
    }
    window['keyboardState'] = (result) => {
      this.keyboardState(result)
    }
  },
  destroyed () {

  }
}
</script>

<style lang="scss" scoped>
* {
  touch-action: pan-y;
}
>>> .mint-indicator {
  .mint-indicator-wrapper {
    z-index: 1000 !important;
  }
  .mint-indicator-mask {
    z-index: 1000 !important;
  }
}

.sectionHeader {
  height: 55px;
  width: 100%;
  z-index: 900;
}
.sectionHeader.isFixed {
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
  z-index: 900;
}
.flex-row {
  /* 水平等比 */
  display: flex;
  flex-direction: row;
}
.flex-column {
  /* 垂直等比 */
  display: flex;
  flex-direction: column;
}
.ct {
  /* 水平、垂直居中 */
  align-items: center;
  justify-content: center;
}
.flex {
  flex: 1;
}
.bg-color {
  background: #f2f2f2;
}
.m-top {
  margin-top: 7px;
}
.m-bottom {
  margin-bottom: 7px;
}
.shop-main-top-layout {
  // top: 55px;
  width: 100%;
  height: 50px;
  position: fixed;
  background: white;
  z-index: 100;
  &.top {
    top: 0;
  }
}
.shop-main-center {
  position: relative;
  z-index: 1;
  // top: 50px;
}
.shop-main-top-classify-layout {
  width: 55px;
  height: 100%;
  font-size: 11px;
}
.shop-main-top-classify-layout-select {
  color: #c41335;
}
.shop-main-top-classify-layout-unselect {
  color: #333333;
}
.shop-main-top-classify-layout img {
  width: 16px;
  height: 16px;
  margin-bottom: 3px;
}
.shop-main-top-search-layout {
  position: relative;
  border-radius: 18px;
  border-width: 1px;
  border-color: #cccccc;
  border-style: solid;
  height: 36px;
  margin-right: 10px;
  margin-left: 13px;
}

.shop-main-top-search-layout input {
  margin-right: 20px;
}

.shop-main-top-search-change-layout {
  height: 36px;
  width: 70px;
}

.shop-main-top-search-change-layout span {
  color: #000000;
  font-size: 12px;
}

.shop-main-top-search-layout img {
  width: 17px;
  height: 17px;
  margin-left: 10px;
  margin-right: 10px;
}
.clearX {
  position: absolute;
  width: 20px;
  height: 20px;
  right: 10px;
  background: url("../../../assets/icon_close_round.svg") no-repeat center
    center;
}
.shop-main-top-search-btn {
  font-size: 12px;
  color: #ffffff;
  height: 32px;
  width: 85px;
  line-height: 32px;
  text-align: center;
  background: #c41335;
  margin-right: 13px;
  border-radius: 25px;
  border-style: none;
}
.shop-main-line {
  width: 100%;
  height: 10px;
}
.shop-main-line2 {
  width: 2px;
  height: 30px;
  background: #f2f2f2;
}
.shop-main-empty {
  width: 100%;
  height: 80px;
  line-height: 80px;
  text-align: center;
  font-size: 12px;
  color: #999999;
  background: white;
  &.top {
    padding-top: 35px;
  }
}
.shop-main-list {
  position: relative;
  background: white;
  padding-left: 9px;
  padding-right: 9px;
  margin-bottom: calc(51px + 50px);
  &.top {
    padding-top: 35px;
  }
  /*margin-bottom: 51px;*/
}
.shop-main-list-item-layout {
  width: calc(50% - 5px - 5px);
  margin-top: 10px;
  border-style: solid;
  border-color: #eeeeee;
  border-width: 1px;
  border-radius: 10px;
  float: left;
  margin-left: 5px;
  margin-right: 5px;
}
.shop-main-list-item-layout img {
  width: 100%;
  height: 175px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-color: #eeeeee;
  border-width: 1px;
  object-fit: contain;
}
.shop-main-list-item-bottom-layout {
  background: #f9f9f9;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border-color: #eeeeee;
  border-width: 1px;
  padding-left: 5px;
  padding-right: 5px;
}
.shop-main-list-item-title {
  color: black;
  font-size: 14px;
  /* 单行显示省略号 */
  max-lines: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  /* 多行显示省略号 */
  /*text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;*/
    
}
.shop-main-list-item-layout .goods-comm-img{
      background: url('https://cdn.zxzx119.com/zxzx-mall-applet/image/ssvip-icon.png') no-repeat;
      background-size: 180px 32px;
      background-position: 0px 20px;
      display: inline;
      padding: 0px 100px;
    }
    .shop-main-list-item-layout  .goods-comm-icon{
      width: 45px;
      height: 13px;
      margin-right: 5px;
      border-top-left-radius: 0px;
  border-top-right-radius: 0px;
    }
.shop-main-list-item-city {
  font-size: 11px;
  color: #999999;
}
.shop-main-list-item-yuan {
  color: #c41335;
  font-size: 12px;
}
.shop-main-list-item-price {
  color: #c41335;
  font-weight: bold;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/view/shopping/goods/index.vue